import { Dialog } from "@mui/material";
import { WorksheetCostCategory } from "generated/graphql";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import AdditionalCostPicker from "./AdditionalCostPicker";
import CrewPicker from "./CrewPicker";
import EquipmentPicker from "./EquipmentPicker";
import PlantProductPicker from "./PlantProductPicker";
import TransferTruckPicker from "./TransferTruckPicker";
import { WorksheetLibraryPickerDialogProps } from "./types";

export default function WorksheetLibraryPickerDialog({
  open,
  category,
  onClose,
  onSelect,
  onSelectMany,
}: WorksheetLibraryPickerDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "12px",
          border: `1px solid ${draftColors.border}`,
          boxShadow: "0px 16px 40px rgba(15, 23, 42, 0.18)",
          maxHeight: "80vh",
        },
      }}
    >
      {category === WorksheetCostCategory.LABOR && (
        <CrewPicker onClose={onClose} onSelect={onSelect} onSelectMany={onSelectMany} />
      )}
      {category === WorksheetCostCategory.EQUIPMENT && (
        <EquipmentPicker onClose={onClose} onSelect={onSelect} onSelectMany={onSelectMany} />
      )}
      {category === WorksheetCostCategory.OTHER && (
        <AdditionalCostPicker onClose={onClose} onSelect={onSelect} onSelectMany={onSelectMany} />
      )}
      {category === WorksheetCostCategory.TRUCKING && (
        <TransferTruckPicker onClose={onClose} onSelect={onSelect} />
      )}
      {category === WorksheetCostCategory.MATERIAL && (
        <PlantProductPicker onClose={onClose} onSelect={onSelect} />
      )}
    </Dialog>
  );
}
